import { FieldValues, UseFormSetError } from 'react-hook-form';
import { handleErrorForm } from '@services/api';
import { Category } from 'interfaces/Category';
import {
  CategoryFilters,
  create,
  list,
  listAll,
  listPinned,
  remove,
  retrieve,
  update,
} from './calls';

export * from './calls';

export default class CategoryAPICaller {
  static adaptFromAPI = (data: Partial<Category>) => {
    const category = {
      ...data,
    };

    return category as FieldValues;
  };

  static adaptToAPI = (data: FieldValues) => {
    const category = {
      ...data,
    };

    return category as Category;
  };

  static list = async (filters: CategoryFilters) => {
    const {
      data: { categories },
    } = await list(filters);

    return {
      ...categories,
      result: categories.result,
    };
  };

  static listAll = async (filters: CategoryFilters) => {
    const {
      data: { categories },
    } = await listAll(filters);

    return {
      ...categories,
      result: categories.result,
    };
  };

  static listPinned = async (
    budgetTemplateId: string,
    costCenterId: string
  ) => {
    const {
      data: { categories },
    } = await listPinned(budgetTemplateId, costCenterId);

    return {
      ...categories,
      result: categories.result,
    };
  };

  static fetch = async (editId: string) => {
    const {
      data: { category },
    } = await retrieve(editId);

    return category;
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;

    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
